import React from "react";
import "./cosmetic_Dentistry.css";
import Teeth_Whiting_img from "../images/laser-teeth-whitening-716468_1920.jpg";
export default function COSMETIC_DENTISTRY() {
  return (
    <div className="container_Cosmetic_Den">
      <h1>COSMETIC DENTISTRY</h1>
      <div className="img_box_Cosmetic_Den">
        <img src={Teeth_Whiting_img} className="img_of_Cosmetic_Den" alt="" />
      </div>
      <div className="text_main_Cosmetic_Den">
        <p>
          Your smile is the first introduction that others have of you, so it
          predict well that you would need it to be brilliant, white and sound.
          As indicated by the Academy of Cosmetic Dentistry, in excess of 99
          percent of every single Indian grown-up believes that a smile is a
          vital part lifestyle. Maybe that is why, such huge numbers of patients
          are choosing corrective dental methods to enhance their smiles and
          lift fearlessness.{" "}
        </p>
        <h1>DID YOU KNOW??</h1>
        <p>
          That cosmetic dentistry is something beyond teeth brightening? The
          White Dental is equipped for changing your grin's shape, shading,
          arrangement, and also filling in holes and tactfully re-establishing
          rotted or harmed teeth, crowns and tooth-hued fillings. Present day
          progressions in cosmetic dentistry have made it feasible for patients
          to accomplish almost culminate teeth with restorative improvements and
          rebuilding efforts that are for all intents and purposes imperceptible
          to companions, family and associates.
        </p>
        <div className="FAQ_Service_Cosmetic_Den">
          <h2>FAQ'S</h2>
        </div>
      </div>
    </div>
  );
}
